import { HiBell } from "react-icons/hi2";

export const BellIcon = ({ width, height, color, ...props }) => (
  <HiBell
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
